<template>
  <iframe v-if="url" :src="url" width="100%" height="100%" frameborder="0" />
  <v-layout
    v-else
    fill-height
    align-center
    justify-center
    style="background-color: var(--primary-normal)"
  >
    <div class="warning-message">
      Service not available
    </div>
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "DashboardPage",

  data() {
    return {
      url: null
    };
  },

  mounted() {
    this.getUrl();
  },

  /**
   * Get url
   * @returns {Promise<void>}
   */
  methods: {
    ...mapActions(["getLicense"]),
    async getUrl() {
      let license = await this.getLicense();
      this.url = license.data.data.cf_bi_url;
    }
  }
};
</script>

<style scoped>
audio:not(.md-image),
canvas:not(.md-image),
embed:not(.md-image),
iframe:not(.md-image),
img:not(.md-image),
object:not(.md-image),
video:not(.md-image) {
  height: 100%;
}

.warning-message {
  color: white;
  font-size: 20px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/BusinessIntelligenceManagement/Dashboards/DashboardPage.vue